import type { LoomMeetingRecorderEligibility } from './useLoomEntryPointVariantState.tsx';

export const getPreloadedLoomMeetingRecorderEligibility = ():
	| LoomMeetingRecorderEligibility
	| undefined => window.__SSR_LOOM_ENTRY_POINT__?.meetingRecorderEligibility;
